import { ArrowBackIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import {
  Badge,
  Box,
  Button,
  Divider,
  Heading,
  HStack,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react";
import linelist from "../../../media/directoryReport.png";
import file from "../../../media/fileTypeImg.png";
import pbi from "../../../media/powerBIReport.png";
import staticImg from "../../../media/staticReport.png";
import tableau from "../../../media/Tableau.png";
const AdminContentPanel = ({ content, onBack, onEdit, onDelete }) => {
  const typeColors = {
    powerbi: "purple",
    tableau: "orange",
    directory: "blue",
    file: "gray",
    static: "teal",
  };

  const IMAGE_ASSETS = {
    pbi,
    linelist,
    staticImg,
    tableau,
    file,
  };

  // Helper function to get the correct image source
  const getImageSource = (cardImg) => {
    if (!cardImg) return staticImg;
    if (cardImg.includes("://")) return cardImg;
    return IMAGE_ASSETS[cardImg] || staticImg;
  };

  const badgeColor = typeColors[content?.type] || "gray";

  return (
    <Box flex={1} p={8} bg="white" minH="calc(100vh - 60px)" overflowY="auto">
      {/* Header with Actions */}
      <HStack justify="space-between" mb={6}>
        <Button leftIcon={<ArrowBackIcon />} onClick={onBack} size="sm">
          Back to Cards
        </Button>
        <HStack>
          <Button
            leftIcon={<EditIcon />}
            colorScheme="blue"
            onClick={onEdit}
            size="sm"
          >
            Edit
          </Button>
          <Button
            leftIcon={<DeleteIcon />}
            colorScheme="red"
            onClick={onDelete}
            size="sm"
          >
            Delete
          </Button>
        </HStack>
      </HStack>

      {/* Content Details */}
      <VStack align="stretch" spacing={6}>
        {/* Image */}
        <Image
          src={getImageSource(content.type)}
          alt={content.title}
          borderRadius="lg"
          objectFit="contain"
          maxH="400px"
          w="100%"
          fallbackSrc="https://via.placeholder.com/800x400?text=No+Image"
        />

        {/* Type Badge */}
        <Box>
          <Badge colorScheme={badgeColor} fontSize="md" px={3} py={1}>
            {content.type === "directory" ? "Folder" : content.type}
          </Badge>
        </Box>

        {/* Title */}
        <Heading size="xl">{content.title}</Heading>

        {/* Subtitle */}
        {content.subTitle && (
          <Text fontSize="lg" color="gray.600" fontWeight="medium">
            {content.subTitle}
          </Text>
        )}

        <Divider />

        {/* Description */}
        {content.desc && (
          <Box>
            <Heading size="md" mb={3}>
              Description
            </Heading>
            <Text fontSize="md" color="gray.700" lineHeight="tall">
              {content.desc}
            </Text>
          </Box>
        )}

        {/* Technical Details */}
        <Box>
          <Heading size="md" mb={3}>
            Technical Details
          </Heading>
          <VStack
            align="stretch"
            spacing={3}
            bg="gray.50"
            p={4}
            borderRadius="md"
          >
            <HStack>
              <Text fontWeight="bold" minW="150px">
                ID:
              </Text>
              <Text fontFamily="mono" fontSize="sm">
                {content.id}
              </Text>
            </HStack>

            <HStack>
              <Text fontWeight="bold" minW="150px">
                Type:
              </Text>
              <Text>
                {" "}
                {content.type === "directory" ? "Folder" : content.type}
              </Text>
            </HStack>

            {content.authGroup && (
              <HStack>
                <Text fontWeight="bold" minW="150px">
                  Auth Group:
                </Text>
                <Text>{content.authGroup}</Text>
              </HStack>
            )}

            {content.embedURL && (
              <HStack align="start">
                <Text fontWeight="bold" minW="150px">
                  Embed URL:
                </Text>
                <Text
                  fontSize="sm"
                  wordBreak="break-all"
                  fontFamily="mono"
                  color="blue.600"
                >
                  {content.embedURL}
                </Text>
              </HStack>
            )}

            {content.workspaceId && (
              <HStack>
                <Text fontWeight="bold" minW="150px">
                  Workspace ID:
                </Text>
                <Text fontFamily="mono" fontSize="sm">
                  {content.workspaceId}
                </Text>
              </HStack>
            )}

            {content.reportId && (
              <HStack>
                <Text fontWeight="bold" minW="150px">
                  Report ID:
                </Text>
                <Text fontFamily="mono" fontSize="sm">
                  {content.reportId}
                </Text>
              </HStack>
            )}

            {content.blobName && (
              <HStack>
                <Text fontWeight="bold" minW="150px">
                  Blob Name:
                </Text>
                <Text fontFamily="mono" fontSize="sm">
                  {content.blobName}
                </Text>
              </HStack>
            )}

            {content.container && (
              <HStack>
                <Text fontWeight="bold" minW="150px">
                  Container:
                </Text>
                <Text fontFamily="mono" fontSize="sm">
                  {content.container}
                </Text>
              </HStack>
            )}
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};

export default AdminContentPanel;
